<template>
    <section class="row mt-3 section-news">
        <div class="container" v-if="inFetching">
            <div class="row">
                <div class="col-12 text-center">
                    <div class="spinner-grow text-danger" role="status">
                        <span class="sr-only">Loading...</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="container" v-else>
            <div class="row mt-3 text-justify news-content" v-html="content"></div>
        </div>
    </section>
</template>

<script>
    import * as _ from 'lodash';

    export default {
        name: "SecurityComponent",
        data() {
            return {
                inFetching: false,
                content: ''
            }
        },
        async mounted() {
            // set inFetching mode
            this.inFetching = true;

            // get security configuration item
            let securityConfigItem = _.find(this.$store.state.configurations.configurationsList, function(configItem) {
                return configItem.configId === process.env.VUE_APP_SECURITY_CONFIG_ID;
            });

            // set page content
            this.content = securityConfigItem.configValue;

            // release inFetching mode
            this.inFetching = false;
        }
    }
</script>

<style scoped>

</style>
